<template>
  <div class="dashboard-follow-up-container">
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="followUpDashboardDetailModal" width="1200">
      <follow-up-dashboard-detail-component v-if="followUpDashboardDetailModal" :missionId="missionId"
        :missionPhoneId="missionPhoneId" :phoneCode="phoneCode"
        :phoneId="phoneId"></follow-up-dashboard-detail-component>
    </v-dialog>
    <app-titled-box title="ماموریت های جاری">
      <template v-slot:title>
        <div class="d-flex gap-1 align-center px-2 header-container">
          <v-icon class="ml-3" @click="refreshList()">mdi-cached mdi-18px</v-icon>
          <div>کد های جاری {{ currentFollowUpCodesList?.length }}</div>
          <div class="search-wrapper">
            <v-text-field hide-details rounded outlined dense placeholder="جستجو..."
              v-model="currentMissionSearchText"></v-text-field>
          </div>
        </div>
      </template>
      <template>
        <v-row no-gutters class="list-container">
          <v-col cols="12">
            <v-row no-gutters>
              <v-col v-for="(item, index) in filteredDashboardData" cols="6" md="4" lg="3" :key="index"
                class="card-column pa-2">
                <dashboard-card v-bind="item" @show-information="showInformation(item)"
                  :my-phone-phone-number="`${item?.phonePhoneNumber}`"
                  :my-patient-phone-numbers="item?.patientPhoneNumbers" :my-mission-id="`${item?.missionId}`"
                  :my-mission-phone-id="`${item?.id}`" @card-click="showConfirmDialogFor10_24(item)"
                  :show1019Icon="true" @card-click-location="invokeToCodeInMap(item)" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </app-titled-box>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import Vue from 'vue';
import throttle from 'lodash/throttle';
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import FollowUpDashboardDetailComponent from '@/components/FollowUp/FollowUpDashboardDetailComponent.vue';
import AppTitledBox from '@/components/app/titledBox.vue';
import DashboardCard from '@/components/FollowUp/Dashboard/Card.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin.js';
import FollowUpDashboardHelper from '@/Helpers/FollowUp/FollowUpDashboardHelper.js';
export default {
  name: 'FollowUpMissionsDashboard',
  title: 'پیگیری',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    FollowUpDashboardDetailComponent,
    DashboardCard,
    AppTitledBox,
    confirmDialog
  },
  mixins: [snackBar, ShearedMixin, ShearedHelper, MissionPhonesMixin, FollowUpDashboardHelper],
  created() {
    this.$root.$refs.FollowUpMissionsDashboard = this;
    this.throttledfollowUp = throttle(this.fCodeListFollowUp, 1500, {
      leading: true,
      trailing: true,
    });
    this.$mainSignalr.bus.$on('CodeListFollowUp', this.throttledfollowUp);
    this.$mobileSignalr.bus.$on('CodeListFollowUp', this.throttledfollowUp);
  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('CodeListFollowUp', this.throttledfollowUp);
    this.$mobileSignalr.bus.$off('CodeListFollowUp', this.throttledfollowUp);

    this.throttledfollowUp.cancel();

    delete this.$root.$refs.FollowUpMissionsDashboard;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      clickItem: null,
      missionListRefreshInFlight: false,
      missionListRefreshPending: false,
    };
  },
  methods: {
    mounte: function () {
      this.getMissionPhoneFollowUpDashboardFunction(true);
    },
    fCodeListFollowUp: async function () {
      if (this.missionListRefreshInFlight) {
        this.missionListRefreshPending = true;
        return;
      }
      this.missionListRefreshInFlight = true;
      try {
        await this.getMissionPhoneFollowUpDashboardFunction(false)
      } catch (error) {
        console.log('getData refresh error:', error);
      } finally {
        this.missionListRefreshInFlight = false;
        if (this.missionListRefreshPending) {
          this.missionListRefreshPending = false;
          this.getMissionPhoneFollowUpDashboardFunction(false);
        }
      }
    },
    invokeToCodeInMap: function (data) {
      try {
        this.selectedRow = data?.id;
        this.clickItem = data;
        const connection = Vue.prototype.$mainSignalr?.connection;
        if (!connection || connection.state !== 'Connected') {
          console.warn('[SignalR2] connection not ready');
          return;
        }
        connection.invoke('Location', data.code.toString()).catch((err) => {
          console.error('[SignalR2] invoke Location failed:', err);
        });
      } catch (error) {
        console.log("A error:", error);
      }
    },
  },
  computed: {
    followUpMissionsFilteredList() {
      return this.dashboardData.filter((u) => {
        return (
          u.code.includes(this.currentMissionSearchText) ||
          u.phoneCurrentState.includes(this.currentMissionSearchText)
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
<style lang="scss" scoped>
.dashboard-follow-up-container {
  padding: 2rem 1rem 0 0;

  .list-container {
    overflow-x: hidden;
    height: 100%;
    overflow-y: auto;
    margin-top: 15px;
  }

  .header-container {
    & {
      background-color: var(--background-color);
    }

    .search-wrapper {
      margin-right: 2rem;
      width: 250px;
      flex-shrink: 0;
      background-color: var(--background-color);
    }
  }
}

.card-column {
  height: fit-content !important;
}

.container-box {
  border: 1px solid var(--dark-color);
  height: calc(100dvh - 78px);
}

@media screen and (max-width: 1440px) {
  .container-box {
    height: calc(100dvh - 82px);
  }
}
</style>
